import { DirectiveBase } from '../angular-directive-base.directive';

/**
 * Renders a status label highlighted with an appropriate colour.
 */
export const TrafficLightStatus: ng.IComponentOptions = {
    controller: () => {
      return;
    },
    controllerAs: 'vm',
    bindings: {
      status: '='
    },
    templateUrl: 'app/angularJS/components/traffic-light-status/traffic-light-status.html'
};